export default __webpack_public_path__ + "static/media/icon-instagram-white.78992feb.svg";